import type { SelectInputChoiceType } from 'src/lib/types';

export const recurrenceTypes = (resource: string): SelectInputChoiceType[] => [
  { id: 'counted', name: `resources.${resource}.recurrenceTypes.counted` },
  { id: 'until', name: `resources.${resource}.recurrenceTypes.until` },
];

export const frequencies = (resource: string): SelectInputChoiceType[] => [
  { id: 'DAILY', name: `resources.${resource}.frequencies.daily` },
  { id: 'WEEKLY', name: `resources.${resource}.frequencies.weekly` },
  { id: 'MONTHLY', name: `resources.${resource}.frequencies.monthly` },
  { id: 'YEARLY', name: `resources.${resource}.frequencies.yearly` },
];

export const weekdays = (resource: string): SelectInputChoiceType[] => [
  { id: 'MO', name: `resources.${resource}.weekdays.mo` },
  { id: 'TU', name: `resources.${resource}.weekdays.tu` },
  { id: 'WE', name: `resources.${resource}.weekdays.we` },
  { id: 'TH', name: `resources.${resource}.weekdays.th` },
  { id: 'FR', name: `resources.${resource}.weekdays.fr` },
  { id: 'SA', name: `resources.${resource}.weekdays.sa` },
  { id: 'SU', name: `resources.${resource}.weekdays.su` },
];

export const monthDays = [...Array(31)].map((_, index) => ({
  id: index + 1,
  name: index + 1,
}));

export const monthNames = (resource: string): SelectInputChoiceType[] =>
  [...Array(12)].map((_, index) => ({
    id: index + 1,
    name: `resources.${resource}.months.${index + 1}`,
  }));
